import React from "react";
import styled from "styled-components";
import { Swatch } from "../Legend/Legend";

/** Ligne "libellé ........ valeur" avec bordure supérieure */
const MiniMetric = ({ label, value, color, mt }) => {
    return (
        <Row style={mt ? { marginTop: mt } : undefined}>
            <span>
                {color && (
                    <Swatch
                        style={{
                            background: color,
                            marginRight: 6,
                            width: 9,
                            height: 9,
                            borderRadius: 2,
                        }}
                    />
                )}
                {label}
            </span>
            <b>{value}</b>
        </Row>
    );
};

export default MiniMetric;

const Row = styled.div`
    font-size: 13px;
    color: var(--prh-muted);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px 0;
    border-top: 1px solid var(--prh-line);
    b {
        color: var(--prh-ink);
        font-weight: 600;
        font-size: var(--prh-font-md);
    }
`;
